import { ArrowUpRight } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";
import { inr } from "@/api";

const SPANS = {
  Bali: "md:col-span-4",
  Maldives: "md:col-span-2",
  Dubai: "md:col-span-2",
  Thailand: "md:col-span-2",
  Singapore: "md:col-span-2",
  Vietnam: "md:col-span-6 md:h-80",
};

export default function Destinations({ destinations, onSelect }) {
  return (
    <section id="destinations" className="scroll-mt-24 py-24 sm:py-32" data-testid="destinations-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Kicker>The Collection</Kicker>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-slate-50 tracking-tight max-w-2xl">
            Six destinations, <em className="gold-text not-italic">infinite</em> stories
          </h2>
          <p className="mt-4 text-slate-400 max-w-xl text-sm sm:text-base">
            Every journey includes return flights, handpicked stays, private transfers and curated sightseeing — tap a destination to see its packages.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-6 gap-5">
          {destinations.map((d, i) => (
            <Reveal key={d.id} delay={i * 0.08} className={`${SPANS[d.name] || "md:col-span-2"}`}>
              <button
                onClick={() => onSelect(d.name)}
                data-testid={`destination-card-${d.name.toLowerCase()}`}
                className="group relative w-full h-72 md:h-full md:min-h-[18rem] rounded-2xl overflow-hidden text-left border border-white/10 hover:border-gold/50 transition-colors duration-500"
              >
                <img src={d.image} alt={`${d.name}, ${d.country}`} loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-onyx-900 via-onyx-900/40 to-transparent" />
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_50%_120%,rgba(212,175,55,0.25),transparent_60%)]" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{d.country}</div>
                  <div className="mt-1 flex items-center justify-between gap-3">
                    <h3 className="font-serif text-2xl sm:text-3xl text-slate-50">{d.name}</h3>
                    <span className="rounded-full border border-gold/40 p-2 text-gold transition-transform duration-500 group-hover:rotate-45">
                      <ArrowUpRight size={16} />
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-slate-300 italic font-serif">{d.tagline}</p>
                  <div className="mt-3 flex items-center gap-3 text-[11px] font-mono uppercase tracking-wider text-slate-400">
                    <span>{d.package_count} packages</span>
                    {d.starting_price != null && <span className="text-gold">from {inr(d.starting_price)}</span>}
                  </div>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
